import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '../../../assets/images/icon_status_-2@3x.png'


const _hoisted_1 = { class: "p-ml-3 p-mr-3 p-mt-3" }
const _hoisted_2 = { class: "p-p-3 shadow bg-color-secondary rounded" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "p-text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "100px",
    src: _imports_0
  })
], -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "p-text-center" }
const _hoisted_6 = {
  style: {"font-size":"26px"},
  class: "p-text-center"
}
const _hoisted_7 = {
  key: 1,
  class: "p-text-center mb-4"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, " หากท่านต้องการแจ้งปัญหา ท่านสามารถติดต่อพนักงานขายของท่าน หรือติดต่อส่วนกลางผ่านช่องทางดังนี้ ", -1)
const _hoisted_9 = { class: "p-mt-2" }
const _hoisted_10 = { class: "p-mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransactionCompleteHeader = _resolveComponent("TransactionCompleteHeader")!
  const _component_TransactionCartDetail = _resolveComponent("TransactionCartDetail")!
  const _component_TransactionAddressDetails = _resolveComponent("TransactionAddressDetails")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_TransactionCompleteHeader, {
        transactionInvoice: _ctx.transaction.invoiceNo,
        statusId: _ctx.transaction.statusId,
        statusName: _ctx.transaction.statusName
      }, null, 8, ["transactionInvoice", "statusId", "statusName"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _hoisted_3,
          (_ctx.transaction.trackingNo.text)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.deliveryText) + " โดยรหัสส่งพัสดุของคุณคือ ", 1),
                _createElementVNode("div", _hoisted_6, _toDisplayString(`${_ctx.transaction.trackingNo.text}`), 1),
                _createElementVNode("p", {
                  class: "p-text-center text-gray pointer",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCheckTrackingStatus && _ctx.onCheckTrackingStatus(...args)))
                }, " คลิกเพื่อตรวจสอบสถานะการจัดส่ง ")
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.deliveryText) + " กรุณารอการอัพเดทหมายเลขพัสดุ ", 1)),
          _hoisted_8,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactInfo, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index + 'contact'
            }, [
              _createElementVNode("div", null, "- " + _toDisplayString(item.name) + ": " + _toDisplayString(item.value), 1)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_TransactionCartDetail, {
          transaction: _ctx.transaction,
          isShowCart: true
        }, null, 8, ["transaction"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_TransactionAddressDetails, {
          buyerInfo: _ctx.transaction.buyerInfo,
          isDisplayAddress: true
        }, null, 8, ["buyerInfo"])
      ])
    ])
  ]))
}